<template>
  <div class="login-container">
    <Loading v-if="$store.state.loading" />
    <Alert v-if="$store.state.alert" />
    <div class="login-content">
      <div>
        <img
          src="../../../assets/img/logo-merah.png"
          class="login-logo"
          alt=""
        />
      </div>
      <div class="login-header">
        <div class="welcome-text">Selamat Datang</div>
        <div class="sub-welcome-text">
          Silakan masukkan informasi login Anda untuk mengakses layanan kami
        </div>
      </div>
      <div class="login-form-container">
        <div class="login-form-wrapper">
          <div class="login-input-field">
            <div class="login-input-label">Email</div>
            <input
              type="text"
              class="login-input"
              placeholder="Email Terdaftar"
              v-model="email"
            />
          </div>
          <div class="login-input-field">
            <div class="login-input-label">Password</div>
            <input
              type="password"
              class="login-input"
              placeholder="********"
              v-model="password"
            />
          </div>
          <div class="link-row">
            <div>
              <router-link to="/register">
                <a>
                  Daftar
                </a>
              </router-link>
            </div>
            <div @click.prevent="forgotPassword">
              <a href="">
                Lupa kata sandi?
              </a>
            </div>
          </div>
          <div class="login-btn" @click="runLogin">Login</div>
          <div class="signin-google-btn cursor-pointer" @click="runGoogleLogin">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1514_10307)">
                <path
                  d="M24.2663 12.2855C24.2663 11.4698 24.2001 10.6497 24.059 9.84717H12.7402V14.4681H19.222C18.953 15.9585 18.0888 17.2769 16.8233 18.1147V21.113H20.6903C22.9611 19.023 24.2663 15.9365 24.2663 12.2855Z"
                  fill="#4285F4"
                />
                <path
                  d="M12.7401 24.0101C15.9766 24.0101 18.7059 22.9475 20.6945 21.1132L16.8276 18.1148C15.7517 18.8468 14.3627 19.2613 12.7445 19.2613C9.61388 19.2613 6.95946 17.1492 6.00705 14.3096H2.0166V17.4005C4.05371 21.4527 8.2029 24.0101 12.7401 24.0101Z"
                  fill="#34A853"
                />
                <path
                  d="M6.00277 14.3095C5.50011 12.8191 5.50011 11.2053 6.00277 9.71497V6.62402H2.01674C0.314734 10.0148 0.314734 14.0097 2.01674 17.4004L6.00277 14.3095Z"
                  fill="#FBBC04"
                />
                <path
                  d="M12.7401 4.75894C14.4509 4.73248 16.1044 5.37624 17.3434 6.55795L20.7695 3.13189C18.6001 1.09478 15.7208 -0.0251887 12.7401 0.010086C8.2029 0.010086 4.05371 2.5675 2.0166 6.62409L6.00264 9.71503C6.95064 6.87101 9.60947 4.75894 12.7401 4.75894Z"
                  fill="#EA4335"
                />
              </g>
              <defs>
                <clipPath id="clip0_1514_10307">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0.5 0.00927734)"
                  />
                </clipPath>
              </defs>
            </svg>
            Masuk dengan Google
          </div>
          <vue-apple-signin
            class="login-apple-btn"
            type="sign in"
            :onSuccess="callsuccess"
          ></vue-apple-signin>
          <div class="email-sipm">
            <p>
              Jika mengalami kendala, mohon dapat menghubungi email
              <a href="#">SIPM_Member_Team@sinarmasmining.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <ModalPass v-if="isForgotPass" @closeForgotPass="closeForgotPass" />
  </div>
</template>
<script>
import { api } from '../../services/config'
import axios from 'axios'
export default {
  components: {
    Loading: () => import('@/components/utils/Loading'),
    Alert: () => import('@/components/Modal/Alert'),
    ModalPass: () => import('@/components/ModalForgotPass.vue'),
  },
  data() {
    return {
      email: '',
      password: '',
      isForgotPass: false,
    }
  },
  methods: {
    callsuccess() {
      console.log('Success: ')
    },
    forgotPassword() {
      this.isForgotPass = true
    },
    closeForgotPass() {
      this.isForgotPass = false
    },
    async runLogin() {
      console.log('run login')
      const self = this
      const url = `${api}/api/v1/auth`
      const authData = {
        email: this.email,
        password: this.password,
      }

      if (
        !this.email ||
        (this.email == '' && !this.password) ||
        this.password == ''
      ) {
        this.$store.commit(
          'SET_NOTIF',
          'Email atau Password tidak boleh kosong!'
        )

        return false
      }

      this.$store.commit('setLoading', true)
      try {
        const { data: auth } = await axios({
          method: 'POST',
          url,
          data: authData,
        })

        if (auth && auth.data) {
          console.log('data login: ', auth.data)
          this.$store.commit('SET_TOKEN', auth.data.token)
          this.$store.commit('SET_PERMISSIONS', auth.data.permission)
          if (auth.data.kode && auth.data.kode.length > 0) {
            this.$store.commit('SET_KODE', auth.data.kode)
          }
          this.email = ''
          this.password = ''
          this.$store.commit('setLoading', false)
          this.$store.commit('AUTO_LOGIN')
          //   this.$router.push({ name: 'home' }, () => {})
        }
      } catch (error) {
        console.log('error', error)
        this.$store.commit('setLoading', false)

        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Server Error')
        )
      }
    },
    async runGoogleLogin() {
      console.log('run google login')
      const self = this
      const url = `${api}/api/v1/auth/google`

      this.$store.commit('setLoading', true)
      try {
        const { data: auth } = await axios({
          method: 'GET',
          url,
        })

        if (auth) {
          console.log('data login: ', auth)
          this.$store.commit('setLoading', false)
          //   this.$router.push({ name: 'home' }, () => {})
          window.open(auth, '_self')
        }
      } catch (error) {
        console.log('error', error)
        this.$store.commit('setLoading', false)

        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Server Error')
        )
      }
    },
  },
}
</script>
